<script setup>

const emit = defineEmits(['timeLimitOverConfirmed']);

</script>

<template>
  <div class="modal com_modal2 fade" id="timeLimitOverConfirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="onCancel"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">ご購入から3ヵ月を経過している為、返品できない場合がございます</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1" @click="emit('timeLimitOverConfirmed')">はい</button>
          <button type="button" class="btn com_btn2" data-bs-dismiss="modal">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>